import React from "react";
import { Leaf, Mountain, BookOpen, Sparkles } from "lucide-react";

const CATEGORIES = [
  {
    icon: Leaf,
    title: "Living Systems",
    items: [
      "Native plants and vegetation communities",
      "Wildlife and significant species",
      "Threatened species habitat",
      "Bush foods and medicinal plants",
      "Seasonal indicators",
    ],
  },
  {
    icon: Mountain,
    title: "Landscape Systems",
    items: [
      "Rivers and wetlands",
      "Groundwater and hydrology",
      "Geology and landforms",
      "Soil systems",
      "Fire patterns and ecological processes",
    ],
  },
  {
    icon: BookOpen,
    title: "Cultural Knowledge",
    items: [
      "Cultural values and stories",
      "Traditional land use",
      "Language and place names",
      "Cultural species and resources",
      "Knowledge transfer priorities",
    ],
  },
  {
    icon: Sparkles,
    title: "Future Opportunities",
    items: [
      "Restoration opportunities",
      "Seed collection areas",
      "Biodiversity market opportunities",
      "Carbon and climate resilience projects",
      "Ranger training priorities",
      "Enterprise development opportunities",
    ],
  },
];

export default function BushMapIncludes() {
  return (
    <section
      id="bush-map-includes"
      data-testid="section-bush-map-includes"
      className="relative py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="bm-eyebrow mb-6">Section 04 — Layers of Country</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2621]">
              What Does a Bush Map Include?
            </h2>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <p className="text-[#584D45] text-lg leading-relaxed">
              Every project is different, but a Bush Map may include any of
              the layers below — chosen and prioritised with community.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {CATEGORIES.map(({ icon: Icon, title, items }, i) => (
            <article
              key={title}
              className="bm-card p-8 md:p-10 flex flex-col relative"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="w-14 h-14 rounded-full bg-[#2C3C2B] text-[#E9C7A8] flex items-center justify-center">
                  <Icon size={22} />
                </span>
                <span className="font-serif-display text-3xl text-[#C5B6A3]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <h3 className="font-serif-display text-2xl md:text-3xl text-[#2D2621] leading-tight">
                {title}
              </h3>

              <ul className="mt-6 space-y-3">
                {items.map((it) => (
                  <li
                    key={it}
                    className="flex items-start gap-3 text-[#584D45] text-[15px] leading-relaxed"
                  >
                    <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-[#A95A3F] shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
